module.exports = __webpack_public_path__ + "img/process.12c0779c.gif";